import { GlobalSettingEnum } from 'api/model';
import useMe from 'contexts/authentication/useMe';
import { useMemo } from 'react';
import useGlobalSettings from './useGlobalSettings';

const useHasAccessToDayPlanning = () => {
  const me = useMe();
  const { parsedData: globalSettings, loaded } = useGlobalSettings();

  const hasAccess = useMemo(() => {
    if (!me || !loaded) {
      return false;
    }

    const allowedUsers =
      globalSettings[GlobalSettingEnum.UsersWithAccessToDayPlanning];

    // If no users configured, hide the feature (must be explicitly enabled)
    const hasAnyUsers = Object.keys(allowedUsers).length > 0;
    if (!hasAnyUsers) {
      return false;
    }

    return allowedUsers[me.userID] === true;
  }, [me, globalSettings, loaded]);

  return hasAccess;
};

export default useHasAccessToDayPlanning;
